import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  UPDATE_APP_STATUS_SAGA,
  IUpdateAppStatusActionSaga,
  UPDATE_AUTH_TOKEN_SAGA,
  IUpdateAuthTokenActionSAGA,
  UPDATE_AUTH_USER_SAGA,
  IUpdateAuthUserActionSAGA,
  UPDATE_GLOBAL_MODAL_SAGA,
  IUpdateGlobalModalActionSAGA,
  LOGIN_AUTH_USER_SAGA,
  ILoginAuthUserActionSAGA,
  IUpdateWebsocketClientActionSAGA,
  UPDATE_WEBSOCKET_CLIENT_SAGA,
  UPDATE_SELECTED_BRANCH_SAGA,
  IUpdateSelectedBranchActionSAGA,
} from "./types";
import {
  updateStatusProps,
  updateAuthTokenExpProps,
  updateAuthUserProps,
  updateGlobalModalProps,
  updateWebsocketClientProps,
  updateSelectedBranchProps,
} from "../../reducers/global/types";
import { validateUser } from "../../api/users";
import { keycloak, initOptions } from "../../store/keycloak";
import usersList from "../../users.json";
import { login } from "../../api/auth";
import { push } from "connected-react-router";
import IBranch from "../../dtos/IBranch";
import { store } from "../../store";

function* updateAppStatus(action: IUpdateAppStatusActionSaga) {
  yield put(updateStatusProps({ appStatus: action.payload.appStatus }));
}

export function* watchUpdateAppStatus() {
  yield takeEvery(UPDATE_APP_STATUS_SAGA, updateAppStatus);
}

function* updateAuthTokenExp(action: IUpdateAuthTokenActionSAGA) {
  yield put(
    updateAuthTokenExpProps({ authTokenExp: action.payload.authTokenExp })
  );
}

export function* watchUpdateAuthTokenExp() {
  yield takeLatest(UPDATE_AUTH_TOKEN_SAGA, updateAuthTokenExp);
}

function* updateAuthUser(action: IUpdateAuthUserActionSAGA) {
  let authUser;
  // authenticate with keycloak
  if (action.payload.authWithKeycloak) {
    const auth: boolean = yield keycloak.init({ onLoad: initOptions.onLoad });
    //Token Refresh
    setInterval(() => {
      keycloak.updateToken(60).then((refreshed: any) => {
        if (refreshed) {
          // console.info('Token refreshed' + refreshed);
          const currentAuthUser = store.getState().globalReducer.authUser;
          store.dispatch(updateAuthUserProps({ authUser: { ...currentAuthUser, ...keycloak } }));
        } else {
          /*console.warn('Token not refreshed, valid for '
            + Math.round(keycloak.tokenParsed.exp + keycloak.timeSkew - new Date().getTime() / 1000) + ' seconds');
          */
        }
      }).catch(() => {
        // console.error('Failed to refresh token');
      });
    }, 6000)
    if (!auth) {
      authUser = {
        error: "failed to login from keycloak",
      };
    } else {
      authUser = keycloak;
    }
  } else {
    // authenticate with basic
    authUser = {
      token: localStorage.getItem("authToken"),
    };
  }
  yield put(updateAuthUserProps({ authUser: authUser }));
  const validationData: {
    userValidated: boolean;
    service_account_id: number | null;
    my_branches: IBranch[] | null;
    user_permissions: { uuid: string, name: string }[]
    user_id: number | null
  } = yield call(validateUser, authUser);

  if (validationData.service_account_id) {
    yield localStorage.setItem(
      "service_account_id",
      validationData.service_account_id
        ? validationData.service_account_id.toString()
        : ""
    );
  }
  yield localStorage.setItem("user_id", validationData.user_id ? validationData.user_id.toString() : "")
  authUser = {
    ...authUser,
    user_permissions: validationData.user_permissions,
    my_branches: validationData.my_branches,
    userValidated: validationData.userValidated,
    user_id: validationData.user_id
  };

  yield put(updateAuthUserProps({ authUser: authUser }));
}

export function* watchUpdateAuthUser() {
  yield takeLatest(UPDATE_AUTH_USER_SAGA, updateAuthUser);
}

function* updateGlobalModal(action: IUpdateGlobalModalActionSAGA) {
  yield put(updateGlobalModalProps({ ...action.payload }));
}

export function* watchUpdateGlobalModal() {
  yield takeLatest(UPDATE_GLOBAL_MODAL_SAGA, updateGlobalModal);
}

function* loginAuthUser(action: ILoginAuthUserActionSAGA) {
  let authUser;
  const results: { token: string; message?: string } = yield call(
    login,
    action.payload.email,
    action.payload.password
  );
  const existingUser: any = usersList.find(
    (u) => u.email == action.payload.email
  );
  if (existingUser) {
    if (results.token) {
      localStorage.setItem("authToken", results.token);
      localStorage.setItem(
        "service_account_id",
        existingUser.service_account_id
      );
      authUser = {
        token: results.token,
      };
    } else if (results.message) {
      alert(results.message);
    }
  } else {
    alert("User not found");
  }
  yield put(updateAuthUserProps({ authUser: authUser }));
}

export function* watchLoginAuthUser() {
  yield takeLatest(LOGIN_AUTH_USER_SAGA, loginAuthUser);
}

function* updateWebsocketClient(action: IUpdateWebsocketClientActionSAGA) {
  yield put(updateWebsocketClientProps({ ...action.payload }));
}

export function* watchWebsocketClient() {
  yield takeLatest(UPDATE_WEBSOCKET_CLIENT_SAGA, updateWebsocketClient);
}

function* updateSelectedBranch(action: IUpdateSelectedBranchActionSAGA) {
  yield put(updateSelectedBranchProps({ ...action.payload }));
}

export function* watchUpdateSelectedBranch() {
  yield takeLatest(UPDATE_SELECTED_BRANCH_SAGA, updateSelectedBranch);
}

export default [
  watchUpdateAppStatus(),
  watchUpdateAuthTokenExp(),
  watchUpdateAuthUser(),
  watchUpdateGlobalModal(),
  watchLoginAuthUser(),
  watchWebsocketClient(),
  watchUpdateSelectedBranch(),
]
